import { gql } from 'graphql-tag'

export const ForgotPassword = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(input: { email: $email }) {
      message
    }
  }
`

export const Login = gql`
  mutation Login($email: String!, $password: String!) {
    login(input: { email: $email, password: $password }) {
      access_token
      refresh_token
      expires_in
      token_type
      user {
        id
        first_name
        last_name
        full_name
        email
        preferred_lang
        is_admin
        is_site_manager
        is_contractor
        active_managing_site {
          id
          name
        }
        managing_sites {
          id
          name
        }
        inductions {
          id
          year
          completed_at
          on_site_training_done
          site {
            id
            name
            address
          }
        }
      }
    }
  }
`

export const ResetPassword = gql`
  mutation ResetPassword($password: String!, $token: String!, $email: String!) {
    resetPassword(
      input: { token: $token, email: $email, password: $password, password_confirmation: $password }
    ) {
      message
    }
  }
`

export const SignUp = gql`
  mutation SignUp(
    $first_name: String
    $last_name: String
    $date_of_birth: Date
    $email: String!
    $password: String!
    $company_id: ID
    $invitation_token: String
  ) {
    register(
      input: {
        first_name: $first_name
        last_name: $last_name
        date_of_birth: $date_of_birth
        email: $email
        password: $password
        password_confirmation: $password
        company_id: $company_id
        invitation_token: $invitation_token
      }
    ) {
      message
    }
  }
`

export const VerifyEmail = gql`
  mutation VerifyEmail($token: String) {
    verifyEmail(input: { token: $token }) {
      access_token
      refresh_token
      expires_in
      token_type
      user {
        id
        first_name
        full_name
        last_name
        email
        preferred_lang
        is_admin
        is_site_manager
        is_contractor
        active_managing_site {
          id
          name
        }
        inductions {
          id
          year
          completed_at
          on_site_training_done
          site {
            id
            name
            address
          }
        }
      }
    }
  }
`
